import { useTranslation } from 'react-i18next'
import { Title } from 'vnetwork-ui'
import GokuDataGrid from '@/components/GokuDataGrid'
import { getResellerServices } from '@/modules/Reseller/services'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { columns } from './columns'
import ServiceIcons from '@/icons/ServiceIcons'

interface ServicesProps {
    resellerId: number
}

const Services: React.FC<ServicesProps> = ({ resellerId }) => {
    const { t } = useTranslation('reseller')

    return (
        <GokuDataGrid
            apiCall={(payload) => getResellerServices(resellerId, payload)}
            columns={columns(t)}
            reactQueryKey={`${QUERY_KEYS.RESELLERS}-services-${resellerId}`}
            dataGridProps={{
                getRowId: (row) => row?.service_id,
            }}
            options={{
                title: (
                    <Title
                        title={t('customer_services')}
                        icon={() => (
                            <ServiceIcons className="text-bg-primary w-6 h-6" />
                        )}
                    />
                ),
                pageSize: 5,
                showSearch: false,
                showHideColumn: false,
            }}
        />
    )
}

export default Services
